"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _bundlePlan = _interopRequireDefault(require("./bundlePlan"));
var _BasicPlan = _interopRequireDefault(require("./BasicPlan"));
var _constants = require("../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ActivePlanSection = function ActivePlanSection() {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state[_constants.PKG_NAME].planDetails;
    }),
    planType = _useSelector.planType;
  return planType === _constants.PLAN_TYPES.basic ? /*#__PURE__*/_react.default.createElement(_BasicPlan.default, null) : /*#__PURE__*/_react.default.createElement(_bundlePlan.default, null);
};
var _default = ActivePlanSection;
exports.default = _default;